import Button from 'components/form/Button';
import TextInput from 'components/form/TextInput';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { handelSpeakerEmailVerify, showSuccess } from 'store/slices';
import { objectToFormData } from 'utils/helpers';

const ConfirmVerification = ({
  setVerificationMethod,
  verificationMethod,
  hadnleOtpSend,
  userEmail,
  otpLoader,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isBtnLoader, setIsBtnLoader] = useState(false);
  const handleSendVerification = async () => {
    setIsBtnLoader(true);
    const response = await dispatch(
      handelSpeakerEmailVerify(objectToFormData({ email: userEmail }))
    );
    if (response?.status === 200) {
      // const response = await dispatch(fetchUserDetails());
      dispatch(showSuccess(response.message));
      navigate(-1);
    }
    setIsBtnLoader(false);
  };

  return (
    <div className="d-flex flex-column justify-content-center">
      <div className="text-center">
        <h5 className="text-24-500-30 cmb-24">
          {verificationMethod === 'otp'
            ? 'OTP Verification'
            : 'Confirm Verification'}
        </h5>
        {verificationMethod === 'otp' ? (
          <p className="text-muted cmb-24">
            To proceed, please verify your email address. An OTP will be sent to
            the email provided below. <br />
            After receiving the OTP, check your inbox and enter it to continue.
          </p>
        ) : (
          <p className="text-muted cmb-24">
            To proceed, please verify your email address. A verification link
            will be sent to the email provided below. <br />
            After receiving the email, check your inbox and click the
            verification link to confirm your email. <br />
            Once verified, you may continue with the process.
          </p>
        )}
      </div>

      <div className="d-flex justify-content-center">
        <div className="w-50">
          <TextInput
            id="email"
            label="Email ID"
            value={userEmail || ''}
            readonly={userEmail}
            className="h-60 p-2 w-100"
            labelClass="mb-2"
          />
        </div>
      </div>

      <div className="d-flex gap-3 justify-content-center w-50 m-auto cpt-14">
        {verificationMethod === 'otp' ? (
          <div className="flex-fill">
            <Button
              text="Send OTP"
              btnStyle="primary-dark"
              className="h-40 w-25"
              onClick={hadnleOtpSend}
              btnLoading={otpLoader}
              disabled={isBtnLoader || otpLoader}
            />
          </div>
        ) : (
          <div className="flex-fill">
            <Button
              text="Send Verification"
              btnStyle="primary-dark"
              className="h-40 w-25"
              onClick={handleSendVerification}
              disabled={isBtnLoader}
              btnLoading={isBtnLoader || otpLoader}
            />
          </div>
        )}
        <div className="flex-fill">
          <Button
            text="Cancel"
            btnStyle="primary-light-outline"
            className="h-40 w-25"
            onClick={() => setVerificationMethod(null)}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmVerification;
